// text contents for Logout.tsx
export const logout = {
	title: `You have been logged out successfully.`,
};
